<template>
  
    <router-view></router-view>
  
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
    @import './css/style.css';
    @import './css/init.css';

</style>



// WEBPACK FOOTER //
// App.vue?b482bcf6